<div class="sh-form-group" *ngIf="profileField$ | async as profileField">
    <dt class="sh-form-group__label sh-description-list__term">{{ profileField.DisplayLabel }}</dt>
    <dl class="sh-form-group__input sh-description-list__details">
        {{ "form.error.unsupported-field" | translate: { type: profileField.FieldDefinition.Type } }}
    </dl>
</div>
